<template>
<div v-if="field">

<v-form 
    ref="form"
    v-model="valid"
    lazy-validation
>
<v-row>

    <v-col>
        <v-row>
            <v-col class="col-12 col-md-6">

                <Select 
                :item="{value:'isreal',name:'Champ réel',liste:[{text:'oui',value:1},{text:'non',value:0}],defaultprops:{show:true,disabled:true}}"
                :change="changeParam"
                :valField="field.isreal"
                />
                <TextField 
                :item="{value:'field',name:'Nom du champ dans la base',defaultprops:{show:true,disabled:true}}"
                :keyup="changeParam"
                :valField="field.field"
                />
                <Select 
                :item="{value:'table',name:'Table liée au champ',liste:listTables,defaultprops:{show:true,modelRules:[v => !!v || 'champ obligatoire'],disabled:field.create}}"
                :change="changeParam"
                :valField="field.table"
                />
            </v-col>
            <v-col class="col-12 col-md-6">

                <TextField 
                :item="{value:'cle',name:'clé de référence',defaultprops:{show:true,modelRules:[v => !!v || 'champ obligatoire'],disabled:field.create}}"

                :keyup="changeParam"
                :valField="field.cle"
                />

                <Select 
                :item="{value:'search',name:'Pour la recherche',liste:listFormat,defaultprops:{show:true}}"
                :change="changeFormat"
                :valField="field.format.search.type"
                />
                <Select 
                :item="{value:'form',name:'Pour les formulaires',liste:listFormat,defaultprops:{show:true}}" 
                :change="changeFormat"
                :valField="field.format.form.type"
                />
            </v-col>
        </v-row>

        <v-tabs background-color="blue lighten-5" v-model="tab">
   
            <v-tab>
                Param. par défaut
            </v-tab> 
            <v-tab>
                Param. table
            </v-tab>
            <v-tab>Aide du champ</v-tab>
            <v-tabs-items v-model="tab" class="pa-2">

                    <v-tab-item class="pa-1">
                        <!--- PARAM PAR DEFAUT -->
                        <v-card>
                        <DefaultParamField
                            v-if="loaded"
                            :params="displays"
                            :page="null"
                            :args="args"
                            :field="field"
                            :field-id="field.id"
                            :entreprises="listEntreprises"
                            :variants="variants"
                            @returnDisplay="changeDisplay"
                            @variants-updated="updateVariants"
                        />
                        </v-card>
                    </v-tab-item>

                    <v-tab-item>

                        <v-tabs background-color="blue lighten-5" v-model="tab2">
                            <v-tab> Relationnels</v-tab> 
                            <v-tab>Synchronisation</v-tab>
                
                            <v-tabs-items v-model="tab2" class="pa-2">
                                <v-tab-item>
                                    <SwitchC
                                    :item="{name:'Montrer le champ lors de l\'import de fichier externe',value:'head',
                                    defaultprops:{show:true}}" 
                                    :change="(item,value) => { field.jonctions.displayonimport = value} "
                                    :valField="field.jonctions.displayonimport" />

                                            n'insérez que des innerjoin ou des leftjoin afin que les requetes prennent l'entièreté de la relation
                                            <Filtre :table="field.table" :filtre="paramsTable.relations" :inModifField="true" @recepVal="(data) => { paramsTable.relations = data}"/>                       
                                </v-tab-item>

                                <v-tab-item v-if="paramsTable.params.calparams">

                                    Si la table fait sujet à une synchronisation de calendrier, veuillez mapper les champs de la table avec les champs de l'api en question                                                             
                                    <SwitchC
                                    :item="{name:'Synchronisation de cette table pour les RDV d\'API externes',value:'head',
                                    defaultprops:{show:true}}" 
                                    :change="(item,value) => { paramsTable.issynccal = value} "
                                    :valField="paramsTable.issynccal" />

                                    <TextField 
                                    :item="{value:'cle',name:'délai en minute pour les synchro',format:'number',defaultprops:{show:true}}"
                                    :keyup="(item,model)=> { paramsTable.params.calparams.syndelai = model }"
                                    :valField="paramsTable.params.calparams.syndelai"
                                    />  

                                        <v-expansion-panels>
                                        <v-expansion-panel>
                                            <v-expansion-panel-header>
                                            1 - RDV utilisé pour les saisies                
                                            </v-expansion-panel-header>

                                            <v-expansion-panel-content class="grey lighten-3">
                                                Mentionnez le la valeur manuelle pour la valeur dynamique qui fait l'objet du type de RDV
                                    <SwitchC
                                    :item="{name:'intitulé du rdv dynamique',value:'head',
                                    defaultprops:{show:true}}" 
                                    :change="(item,value) => { paramsTable.params.calparams.rdv.dynamic = value} "
                                    :valField="paramsTable.params.calparams.rdv.dynamic" />
                                    <Select 
                                    :item="{value:'table',name:'Table ciblée',liste:listTables,defaultprops:{show:true}}"
                                    :change="(item,model) => { paramsTable.params.calparams.rdv.query.table = model.value }"
                                    :valField="paramsTable.params.calparams.rdv.query.table"
                                    />
                                    <v-tabs background-color="blue lighten-5" v-model="tab3">
                                        <v-tab v-if="paramsTable.params.calparams.rdv.dynamic && paramsTable.params.calparams.rdv.query.table">requete</v-tab> 
                                        <v-tab v-if="paramsTable.params.calparams.rdv.dynamic && paramsTable.params.calparams.rdv.query.table">Champs</v-tab>
                                        <v-tab>mapping</v-tab>
                                        <v-tabs-items v-model="tab3">
                                        <v-tab-item v-if="paramsTable.params.calparams.rdv.dynamic && paramsTable.params.calparams.rdv.query.table">
                                            <Filtre :table="paramsTable.params.calparams.rdv.query.table" :filtre="paramsTable.params.calparams.rdv.query.filtre" 
                                            @recepVal="(data) => { paramsTable.params.calparams.rdv.query.filtre = data}"/>
                                        </v-tab-item> 
                                        <v-tab-item v-if="paramsTable.params.calparams.rdv.dynamic && paramsTable.params.calparams.rdv.query.table">
                                            <Fields :table="paramsTable.params.calparams.rdv.query.table" :filter="paramsTable.params.calparams.rdv.query.filtre"
                                            :champs="paramsTable.params.calparams.rdv.query.champs"
                                            :modalKey="modalKey" args="" :page="null"
                                            @recepVal="(Rfield) => {paramsTable.params.calparams.rdv.query.champs = Rfield}"/>
                                        </v-tab-item>      
                                        <v-tab-item>
                                                <TextField 
                                                :item="{value:'cle',name:'Titre du RDV',defaultprops:{show:true}}"
                                                :keyup="(item,model)=> { paramsTable.params.calparams.rdv.title = model }"
                                                :valField="paramsTable.params.calparams.rdv.title"
                                                />   
                                                <TextField 
                                                :item="{value:'cle',name:'ID du rdv (necessaire si dynamique)',defaultprops:{show:true}}"
                                                :keyup="(item,model)=> { paramsTable.params.calparams.rdv.id = model }"
                                                :valField="paramsTable.params.calparams.rdv.id"
                                                />                                                                                              
                                        </v-tab-item>                                      
                                        </v-tabs-items>
                                    </v-tabs>                                                
                                            </v-expansion-panel-content>  
                                        </v-expansion-panel>
                                        <v-expansion-panel> 
                                            <v-expansion-panel-header>
                                            2 - récupération des tables sujets à infos, et du champ utilisateur                
                                            </v-expansion-panel-header>

                                            <v-expansion-panel-content class="grey lighten-3">  
                                                <Select 
                                                :item="{value:'table',name:'Table ou se trouve l\'ID unique des RDV externes',liste:tablesRelList,defaultprops:{show:true}}"
                                                :change="(item,model) => { paramsTable.params.calparams.tablesmap.eventapiid = model.value }"
                                                :valField="paramsTable.params.calparams.tablesmap.eventapiid"
                                                />                                                                                             
                                                <Select 
                                                :item="{value:'search',name:'Champ utilisateur en relation avec le compte externe',liste:listFieldsInTable,defaultprops:{show:true}}"
                                                :change="(item,model) => { paramsTable.params.calparams.tablesmap.fielduser = model.value }"
                                                :valField="paramsTable.params.calparams.tablesmap.fielduser"
                                                /> Doit être obligatoirement un champ de la table {{ field.table }}                                 
                                            </v-expansion-panel-content>
                                        </v-expansion-panel> 
                                        <v-expansion-panel> 
                                            <v-expansion-panel-header>
                                            3 - récupération des infos du RDV                
                                            </v-expansion-panel-header>

                                            <v-expansion-panel-content class="grey lighten-3">  
                                                <v-tabs background-color="blue lighten-5" v-model="tab4">
                                                    <v-tab>filtre</v-tab> 
                                                    <v-tab>champs</v-tab>                                           
                                                        <v-tabs-items v-model="tab4">
                                                          <v-tab-item>                                                          
                                                            <Filtre :table="field.table" :filtre="paramsTable.params.calparams.query.filtre" @recepVal="(data) => { paramsTable.params.calparams.query.filtre = data}"/>
                                                        </v-tab-item> 
                                                          <v-tab-item>
                                                            <Fields :table="field.table" :filter="paramsTable.params.calparams.query.filtre"
                                                            :champs="paramsTable.params.calparams.query.champs"
                                                            :modalKey="modalKey" args="" :page="null"
                                                            @recepVal="(Rfield) => {paramsTable.params.calparams.query.champs = Rfield}"/>
                                                        </v-tab-item>                                                                                                               
                                                        </v-tabs-items>
                                                </v-tabs>                                
                                            </v-expansion-panel-content>
                                        </v-expansion-panel> 
                                        <v-expansion-panel> 
                                            <v-expansion-panel-header>
                                            4 - Mapping des infos sur actions                 
                                            </v-expansion-panel-header>

                                            <v-expansion-panel-content class="grey lighten-3">    
                                                    <v-row>
                                                    <v-col>
                                                        <Select 
                                                        :item="{value:'search',name:'Date de début',liste:listFieldsInTable,defaultprops:{show:true}}"
                                                        :change="(item,model) => {paramsTable.params.calparams.mappfields.primary.start = model.value}"
                                                        :valField="paramsTable.params.calparams.mappfields.primary.start"
                                                        />
                                                    </v-col>
                                                    <v-col>
                                                        <Select 
                                                        :item="{value:'search',name:'Date de fin',liste:listFieldsInTable,defaultprops:{show:true}}"
                                                        :change="(item,model) => {paramsTable.params.calparams.mappfields.primary.end = model.value}"
                                                        :valField="paramsTable.params.calparams.mappfields.primary.end"
                                                        /> 
                                                    </v-col>
                                                    <v-col>
                                                    <Select 
                                                        :item="{value:'search',name:'récurrence',liste:listFieldsInTable,defaultprops:{show:true,description:'non obligatoire, laisser vide si aucune récurrence'}}"
                                                        :change="(item,model) => {paramsTable.params.calparams.mappfields.primary.recurrence = model.value}"
                                                        :valField="paramsTable.params.calparams.mappfields.primary.recurrence"
                                                        />    
                                                    </v-col>                                                    
                                                    </v-row>
                                                           
                                                                                                        
                                                <p>Liste des valeurs externes possibles à insérer en local (utilser [[line||xxxx]]) :</p> 
                                                <p>- summary, description, location (de l'API)</p>
                                                <p>- Variables de requete de RDV utilisé pour les saisies (1)</p>
                                                <p>- Variables des infos du RDV (3)</p>
                                                <v-tabs background-color="blue lighten-5" v-model="tab5">
                                                
                                                    <v-tab v-for="(v,i) in variablesFields" :key="i">{{v.name}}</v-tab>
                                                    <v-tab>Insertion externe</v-tab>
                                                    <v-tab>modification externe</v-tab>
                                                                              
                                                        <v-tabs-items v-model="tab5">
                                                        <v-tab-item v-for="(v,i) in variablesFields" :key="i">
                                                            {{ v.desc }}
                                                        <Select 
                                                        :item="{value:'search',name:'Intégration d\'un champ',liste:listFieldsInTable,defaultprops:{show:true}}"
                                                        :change="(item,model) => {paramsTable.params.calparams.mappfields[v.val].push({key:model.value,value:''});}"
                                                        /> 
                                                        <div v-for="(mm,i) in paramsTable.params.calparams.mappfields[v.val]" :key="'f'+i" class="d-flex col-12">
                                                            <v-row>
                                                                <v-col class="col-10">
                                                                    <TextField 
                                                                    :item="{value:'cle',name:mm.key,defaultprops:{show:true}}"
                                                                    :keyup="(item,model)=> { mm.value = model }"
                                                                    :valField="mm.value"
                                                                    />                                                                     
                                                                </v-col>
                                                                <v-col class="col-2">
                                                                <v-btn class="ml-2" x-small @click="paramsTable.params.calparams.mappfields[v.val].splice(i, 1)">X</v-btn>    
                                                                </v-col>
                                                            </v-row>
   
                                                                                                                 
                                                        </div>                                                                                                                                                                              
                                                        </v-tab-item>     

                                                        <v-tab-item>
                                                            Quand un RDV est inséré localement, il va s'insérer dans le cal. distant. renseignez les champs du cal. distant pour les alimenter.
                                                            <div v-for="(val,key) in paramsTable.params.calparams.mappfields.insertext" :key="'i'+key">
                                                            <TextField 
                                                            :item="{value:'cle',name:key,defaultprops:{show:true}}"
                                                            :keyup="(item,model)=> { paramsTable.params.calparams.mappfields.insertext[key] = model }"
                                                            :valField="paramsTable.params.calparams.mappfields.insertext[key]"
                                                            />                                                            
                                                            </div>                                                            
                                                        </v-tab-item>     
                                                        <v-tab-item>
                                                            Quand vous modifiez un RDV, il va etre modifié sur la cal. distant, renseignez ce que vous souhaitez voir modifié. (ne mettez rien si ce champ ne doit pas etre impacté)
                                                            <div v-for="(val,key) in paramsTable.params.calparams.mappfields.updateext" :key="'i'+key">
                                                            <TextField 
                                                            :item="{value:'cle',name:key,defaultprops:{show:true}}"
                                                            :keyup="(item,model)=> { paramsTable.params.calparams.mappfields.updateext[key] = model }"
                                                            :valField="paramsTable.params.calparams.mappfields.updateext[key]"
                                                            />                                                            
                                                            </div>                                                            
                                                        </v-tab-item>                                                                                                                                                                                                                                                                                                                              
                                                        </v-tabs-items>
                                                </v-tabs>                                
                                            </v-expansion-panel-content>
                                        </v-expansion-panel>                                                                                                                      
                                        </v-expansion-panels>

                                </v-tab-item>
                            </v-tabs-items>                    
                            </v-tabs>      
                    </v-tab-item>

                    <v-tab-item>
                        <FieldHelpEditor v-if="loaded && field.help" v-model="field.help" :available="helpAvailable" />
                    </v-tab-item>
            </v-tabs-items>
        </v-tabs>

        

    </v-col>
</v-row>
    <v-row>
        <v-col class="text-center">
            <v-spacer></v-spacer>
         <v-btn class="primary" @click="validate" :disabled="!valid">Enregistrer</v-btn>
        </v-col>
    </v-row>
</v-form>

</div>

</template>


<script>
    import { fieldEditorLocation } from './navigation'

    export default {
        name : 'FormModule',
        props : {
            fieldId: { type: [String, Number], default: 'new' },
            fieldName: { type: String, default: '' },
            table: { type: String, default: '' },
            contextKey: { type: String, default: '' },
            embedded: { type: Boolean, default: false },
            standalone: { type: Boolean, default: false },
        },

        components : {
            FieldHelpEditor: () => import('./FieldHelpEditor.vue'),
            Select   : () => import('../../fields/select.vue'),
            TextField   : () => import('../../fields/textfield.vue'),
            DefaultParamField : () => import('./defaultField/defaultParamField.vue'),  
            Filtre   : () => import('../outils/constructFiltre/Filtre.vue'), 
            Fields: () => import("../outils/constructField/Field.vue"),
            SwitchC: () => import("../../fields/switch.vue"),       

        },

        data: function() {
            return { 

                valid : false,
                listTables : [],
                displays :false,
                field : false,
                helpAvailable: false,
                createArrayField : {name:'',type:'',default:''},
                editedIndex : -1,
                dialog : false,
                loaded : false,
                // paramètres fournis aux sous-composants de configuration du champ
                args : { params: {} },
                currentFieldId: this.fieldId,
                internalContextKey: `edit-field-${this._uid}`,
                tab: null,
                tab2 : '',
                tab3 : '',
                tab4 : '',
                tab5 : '',
                listFormat : [],
                listEntreprises : [],
                variants : {},
                paramsTable : [],
                listMap : [],
                listFieldsInTable : [],
                variablesFields : [{name:'insertion locale',val:'insertlocal',desc:'Quand un RDV est inséré sur le calendrier distant, il se duplique dans le systeme, vous pouvez définir quelles infos vont être insérés dans le systeme (hors champs dates et recurrence)'},
                {name:'modif locale',val:'updatelocal',desc:' quand une RDV distant est modifié, vous pouvez cibler les champs qui seront impactés dans le systeme'}]

            }
        },

  computed : {
    modalKey() {
        return this.contextKey || this.internalContextKey
    },

    getFieldsMap() {
        let fields = [];
        this.paramsTable.params.calparams.query.champs.forEach((v) => {
            fields.push({text:v.field,value:v.as})
        })
        return fields;
    },

    tablesRelList() {
        let list = []
        this.paramsTable.relations.map(item => {
            const table = item.param.table;
            list.push({
                text: table,
                value: table
            });
        });
        if(this.field.table) list.push({text:this.field.table,value:this.field.table})
        return list
    }
  },

        methods : {

            validate(){
                var params = { field: this.field, displays: this.displays };

                if(params.field.format.form.type=='select' && params.displays.liste.length==0) {
                    alert('vous devez remplir des valeurs pour l\'affichage dans les tableaux')
                    return false;
                }
                if(params.displays.name=='' && params.field.format.form.type!='arrayfield') {
                    alert('vous devez remplir un intitulé pour l\'affichage de colonne dans les tableaux')
                    return false;
                }
                 this.$store.dispatch('getoverlay',true)
                 this.API({type:'put', url:'/engine/field/edit', params:{id:this.field.id || false, fields:params,paramsTable:this.paramsTable,variant : 0}}).then((resp) => {

                        this.field = resp.data.field
                        this.helpAvailable = resp.data.helpAvailable === true
                        this.displays = resp.data.displays;
                        this.variants = resp.data.variants || this.variants;
                        const wasNew = String(this.currentFieldId) === 'new'
                        this.currentFieldId = resp.data.field.id
                        this.args.params = { id: this.currentFieldId }
                        this.$emit('saved', { field: this.field, displays: this.displays })
                        if (wasNew && this.standalone && this.$route.name === 'engine-field-edit') {
                            this.$router.replace(fieldEditorLocation({ id: this.currentFieldId }))
                        }
                        this.$store.dispatch('getoverlay',false)

                    })


            },

            changeFormat(item,value,selectedKey) {
                this.field.format[item.value]['type'] = value[selectedKey]
            },
            changeParam(item,value,selectedKey) {
                this.field[item.value] = value[selectedKey]
            },

            changeDisplay(data) {
                this.displays = data
            },

            updateVariants(variants) {
                this.variants = variants || {}
                this.$emit('variant-saved', { field: this.field, variants: this.variants })
            },
            
            getFromAPI() {
                const params = String(this.currentFieldId) !== 'new'
                    ? { id: this.currentFieldId }
                    : { name: this.fieldName, table: this.table }
                this.args.params = params
                this.API({type:'post', url:'/engine/field/edit', params}).then((resp) => {
                        this.field = resp.data.field
                        this.helpAvailable = resp.data.helpAvailable === true
                        this.getListFields(this.field.table)
                        this.displays = resp.data.displays;
                        this.variants = resp.data.variants || {};
                        this.paramsTable = resp.data.paramsTable;
                        this.listFormat = resp.data.listTypeFields;
                        this.loaded = true;
                    })

            },


            getListFields(table) {
                this.listFieldsInTable = []
                this.API({ type: 'post', url: 'engine/module/getfieldswithjunctions', params: {table:table,filter:[]} }).then((resp) => {
                            resp.data.fields.forEach((field) => {
                                this.listFieldsInTable.push({ 'text': field.field, value:field.cle, default:"value" })
                            })
                    })
            },

        },
    
        mounted() {          
        this.API({type:'get', url:'engine/getlisttable', params:{}}).then((resp) => { 
                    var that = this
                    resp.data.forEach(function(table){
                        that.listTables.push({text:table,value:table})
                    })
                    
                })
        this.API({type:'post', url:'engine/entreprises/list', params:{}}).then((resp) => { 
                    
                    this.listEntreprises = resp.data
                    
                })

        this.getFromAPI()
        }

    }

</script>
